<template>
    <div></div>
</template>

<script setup>
import { wxLogin } from '@/api/api';
import { saveUserInfo, getWxLoginState } from '@/utils/common';
import Router from '@/router/index'
import { onMounted } from 'vue';

const wxLoginHandler = () => {
    // 获取当前 URL 的查询参数部分（?code=xxx&state=yyy）
    const queryString = window.location.search;
    // 使用 URLSearchParams 解析查询参数
    const urlParams = new URLSearchParams(queryString);
    // 获取具体的参数值
    const code = urlParams.get("code"); // 获取 code 参数
    const state = urlParams.get("state"); // 获取 state 参数

    const cacheState = getWxLoginState();

    console.log("code:", code);
    console.log("state:", state);
    console.log("cacheState", cacheState)
    if(code && state && cacheState == state){
        wxLogin({code: code}).then((response) => {
            const res = response.data;
            console.log(res);
            const userInfo = res.data;
            window.localStorage.setItem('token', userInfo.token)
            saveUserInfo(userInfo);
            if(userInfo.name){
                Router.push('/')
            }else{
                Router.push('/personalInfo')
            }
        })
    }else{
        Router.push('/signin')
    }

}

onMounted(() => {
    wxLoginHandler();
})

</script>
